import isAfter from 'date-fns/isAfter';
import isFuture from 'date-fns/isFuture';
import addYears from 'date-fns/addYears';
import Cookie from 'js-cookie';
import { getDomain } from '../../../../../utils/getDomain';

const COOKIE_NAME = 'tos_acceptance_date';

let creating = false;

export function createCookie(isEmbed) {
  return new Promise((resolve) => {
    const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if (isSafari && isEmbed) {
      if (creating) {
        return;
      }

      creating = true;

      const connector = () => (global.location.href.indexOf('?') ? '&' : '?');
      const url = `${global.location.href}${connector()}setTOS=true`;

      const cookieWindow = window.open(
        url,
        'createcookie',
        'left=0,top=0,innerHeight=1,innerWidth=1;modal=yes;alwaysLowered=yes',
      );
      // we should wait for the new window to close but that cause a delay on dismissing
      // the notification to avoid delaying the user experience we opted to resolve this
      // early and allow the user to see the app while the cookie is being created
      resolve({ continueWithoutVerify: true });

      const checkTimer = setInterval(() => {
        if (cookieWindow.closed) {
          clearInterval(checkTimer);
          creating = false;
        }
      }, 250);
    } else {
      const expires = addYears(new Date(), 10);
      const domain = getDomain();

      const cookieValue = new Date().getTime();

      Cookie.set(COOKIE_NAME, cookieValue, {
        expires,
        domain,
      });
      resolve({});
    }
  });
}

export function validateCookie(privacyPolicyLastUpdated = 0) {
  const cookieValue = parseInt(Cookie.get(COOKIE_NAME) || 0, 10);

  if (privacyPolicyLastUpdated === 0) {
    return !!cookieValue;
  }

  const isPrivacyPolicyLastUpdatedInFuture = isFuture(privacyPolicyLastUpdated);
  // cookievalue is after privacy policy last updated
  const isCookieValueValid = isAfter(cookieValue, privacyPolicyLastUpdated);

  return isPrivacyPolicyLastUpdatedInFuture || isCookieValueValid;
}
